export function isObject(obj: any, strictMode: boolean = true): boolean {
    const isObj = obj === Object(obj);
    if (!strictMode) return isObj;

    const isArray = obj instanceof Array;
    return !isArray && isObj;
}
